import { FunnelField } from "./types";

export function validateStepFields(
  fields: FunnelField[],
  data: Record<string, any>
): Record<string, string> {
  const errors: Record<string, string> = {};

  for (const field of fields) {
    // Skip hidden fields
    if (field.visibleWhen) {
      const { field: depField, operator, value } = field.visibleWhen;
      const depValue = data[depField];
      let visible = true;
      switch (operator) {
        case "eq":
          visible = depValue === value;
          break;
        case "neq":
          visible = depValue !== value;
          break;
        case "in":
          visible = Array.isArray(value) && value.includes(depValue);
          break;
        case "exists":
          visible = depValue != null && depValue !== "" && depValue !== false;
          break;
      }
      if (!visible) continue;
    }

    const value = data[field.name];

    // Required check
    if (field.required) {
      if (field.required === "answered") {
        // Toggle fields: null/undefined means not answered, but false is a valid answer
        if (value == null) {
          errors[field.name] = "field_is_required";
          continue;
        }
      } else if (
        value == null ||
        value === "" ||
        value === false ||
        // Multi-value custom fields (e.g. positionIds): nothing chosen.
        (Array.isArray(value) && value.length === 0 && field.type === "custom")
      ) {
        errors[field.name] = "field_is_required";
        continue;
      }
    }

    // Skip further validation if empty and not required
    if (value == null || value === "") continue;

    // Pattern validation
    if (field.validation?.pattern) {
      const regex = new RegExp(field.validation.pattern);
      if (typeof value === "string" && !regex.test(value)) {
        errors[field.name] = "invalid_format";
      }
    }

    // Min/Max for numbers (coerce strings from number inputs that haven't blurred)
    if (field.validation?.min != null || field.validation?.max != null) {
      const numValue = typeof value === "number" ? value : Number(value);
      if (!isNaN(numValue)) {
        if (field.validation?.min != null && numValue < field.validation.min) {
          errors[field.name] = "value_too_small";
        }
        if (field.validation?.max != null && numValue > field.validation.max) {
          errors[field.name] = "value_too_large";
        }
      }
    }

    // MinLength/MaxLength for strings
    if (field.validation?.minLength != null && typeof value === "string") {
      if (value.length < field.validation.minLength) {
        errors[field.name] = "value_too_short";
      }
    }
    if (field.validation?.maxLength != null && typeof value === "string") {
      if (value.length > field.validation.maxLength) {
        errors[field.name] = "value_too_long";
      }
    }

    // Repeater sub-field validation
    if (field.type === "repeater" && Array.isArray(value) && field.repeaterFields) {
      for (let i = 0; i < value.length; i++) {
        for (const sf of field.repeaterFields) {
          if (sf.required) {
            const sv = value[i]?.[sf.name];
            if (sv == null || sv === "") {
              errors[`${field.name}.${i}.${sf.name}`] = "field_is_required";
            }
          }
        }
      }
    }
  }

  return errors;
}
